<template>
    <button class="btn" :class="`btn-${props.size} btn-${props.variant}`" :type="type" :disabled="disabled || loading">
        <i v-if="icon" class="bi pe-1" :class="icon" aria-hidden="true"></i>
        <slot></slot>
    </button>
</template>
<script setup lang="ts">

const props = withDefaults(defineProps<{
    size?: "sm" | "md" | "lg";
    variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
    icon?: string;
    type?: string;
    disabled?: boolean,
    loading?: boolean;
}>(), {
    size: "md",
    variant: "primary",
    type: "button",
    loading: false,
    disabled: false
})
</script>